import { ReactElement } from 'react';

import { Badge } from 'components/elements/badge/badge';
import { BadgeType } from 'components/elements/badge/types';
import IconChecked from 'components/icons/checked';
import IconCross from 'components/icons/cross';
import IconDash from 'components/icons/dash';
import IconRefresh from 'components/icons/refresh';

import { CustodialWalletTransactionStatus } from 'types/custodialWallet';
import { PwcOrderStatus } from 'types/pwcOrder';

import { badgePropsMap } from './keys';
import { BadgeContent } from './styles';

interface StatusBadgeProps {
  status: CustodialWalletTransactionStatus;
}

const badgeToIconMap: Record<CustodialWalletTransactionStatus, ReactElement | null> = {
  [CustodialWalletTransactionStatus.Submitted]: <IconRefresh />,
  [CustodialWalletTransactionStatus.Completed]: <IconChecked />,
  [CustodialWalletTransactionStatus.Failed]: <IconCross />,
};

const badgeTypeMap: Record<CustodialWalletTransactionStatus, BadgeType> = {
  [PwcOrderStatus.Submitted]: BadgeType.Default,
  [PwcOrderStatus.Completed]: BadgeType.Success,
  [PwcOrderStatus.Failed]: BadgeType.Fail,
};

export const CustodialWalletTransactionStatusBadge = ({ status }: StatusBadgeProps) => {
  const { type, label } = badgePropsMap[status] || badgePropsMap[CustodialWalletTransactionStatus.Submitted];
  const icon = badgeToIconMap[type];
  const badgeType = badgeTypeMap[type];

  const usedLabel = label || <IconDash />;

  return (
    <Badge type={badgeType}>
      <BadgeContent>
        {icon}
        {usedLabel}
      </BadgeContent>
    </Badge>
  );
};
